import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { WCGroupLooserDataDto, WCGroupWinnerDataDto } from "app/models";

@Component({
    selector: 'draw-wc-group-looser-modal',
    templateUrl: './draw-wc-group-looser.modal.html',
    styleUrls: ['./draw-wc-group-looser.modal.scss'],
})
export class DrawWCGroupLooserModal implements OnInit {
    @Input() groups: string[];

    line: number;
    teamCount: number;
    selectedGroups: string[] = [];

    constructor(public activeModal: NgbActiveModal) {
    }
    ngOnInit(): void {
        if (this.groups) {
            this.groups.forEach(item => {
                this.selectedGroups.push(item);
            })
        }
    }
    
    selectGroup(groupName: string) {
        let selectedGroup = this.selectedGroups.indexOf(groupName)
        if (selectedGroup < 0) {
            this.selectedGroups.push(groupName);
        } else {
            this.selectedGroups.splice(selectedGroup, 1);
        }
    }

    isGroupSelected(groupName): boolean {
        let selectedGroup = this.selectedGroups.indexOf(groupName)
        return selectedGroup < 0 ? false : true;
    }

    onSubmit() {
        if (this.line && this.line > 0 && this.selectedGroups.length > 0 && this.teamCount && this.teamCount > 0) {
            let result = new WCGroupLooserDataDto();
            result.line = this.line;
            result.groups = this.selectedGroups.sort();
            result.count = this.teamCount;

            this.activeModal.close(result);
        }
    }
}